module.exports = __webpack_public_path__ + "img/notification-bell.eccfca1b.png";